module.exports = __webpack_public_path__ + "static/media/bannerS.85efc113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bannerS.jpg
// module id = 290
// module chunks = 0